<template>
  <q-dialog v-model="show" seamless position="bottom">
    <q-card style="width: 440px; max-width: 92vw" class="q-pa-xs">
      <q-card-section class="row items-center no-wrap">
        <q-icon name="notifications_active" size="34px" color="primary" class="q-mr-md" />
        <div>
          <div class="text-subtitle2">{{ tt('appPush.promptTitle', 'Activer les notifications ?') }}</div>
          <div class="text-caption text-grey-7">
            {{ tt('appPush.promptBody', "Soyez prévenu·e en temps réel, même l'application fermée.") }}
          </div>
        </div>
      </q-card-section>
      <q-card-actions align="right" class="q-pt-none">
        <q-btn flat dense no-caps color="grey-7" :label="tt('appPush.later', 'Plus tard')" @click="later" />
        <q-btn unelevated dense no-caps color="primary" :loading="appPushStore.busy"
               :label="tt('appPush.enable', 'Activer')" @click="enable" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import {mapStores} from 'pinia';
import {useAppPushStore} from '@core/stores/app/appPushStore';
import {useAuthStore} from '@core/stores/authStore';
import AppPushService from '@core/services/app/appPushService';

const DISMISS_KEY = 'app_push_prompt_dismissed_at';
const SNOOZE_DAYS = 14;

export default {
  name: 'AppPushPrompt',

  data() {
    return {show: false};
  },

  computed: {
    ...mapStores(useAppPushStore, useAuthStore),
  },

  methods: {
    tt(key, fallback) {
      const v = this.$t(key);
      return (!v || v === key) ? fallback : v;
    },

    eligible() {
      const s = this.appPushStore;
      if (!s.supported || s.isEnabled || s.isBlocked) return false;
      if (!this.authStore?.isLoggedIn) return false;
      try {
        const at = Number(localStorage.getItem(DISMISS_KEY) || 0);
        if (at && (Date.now() - at) < SNOOZE_DAYS * 86400000) return false;
      } catch (e) { /* localStorage indispo */ }
      return true;
    },

    async enable() {
      await AppPushService.enable();
      this.show = false; // succès → isEnabled ; échec/refus → isBlocked : on ne renvoie pas le bandeau
    },

    later() {
      try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (e) { /* noop */ }
      this.show = false;
    },
  },

  mounted() {
    // Laisse l'app se charger (et syncState peupler le store) avant de proposer.
    this._timer = setTimeout(() => { if (this.eligible()) this.show = true; }, 4000);
  },

  beforeUnmount() {
    if (this._timer) clearTimeout(this._timer);
  },
}
</script>
